import { ref, watch } from 'vue'
import { useLoadScheduleItem } from '@/widgets/CabinetScheduleItem/model/api.ts'
import type { ScheduleType } from '@/entities/Schedule'
import { cloneDeep, toArray } from 'lodash'
import { DateTime } from 'ts-luxon'

export const useModel = () => {
  const data = ref<ScheduleType | null>(null)
  const scheduleData = ref<any>(null)

  /**
   * Загружаем данные по расписанию
   * @param scheduleId
   */
  const loadData = (scheduleId: number) => {
    const result = useLoadScheduleItem(scheduleId)

    watch(result.data, () => {
      if (result.data.value) {
        data.value = result.data.value.data
        scheduleData.value = getProgramData(
          getProgramToDay(cloneDeep(result.data.value.data.json || {})),
        )
      }
    })

    return result
  }

  /**
   * Получаем расписание текущего расписания
   * @param value
   */
  const getProgramToDay = (value: any) => {
    const date = DateTime.now()

    const keys = Object.keys(value)
      .map(Number)
      .sort((a, b) => b - a)

    for (const key of keys) {
      const entry = value[key]

      const entryDay = parseInt(entry.d)
      const entryMonth = parseInt(entry.m)

      if (entryMonth < date.month || (entryMonth === date.month && entryDay <= date.day)) {
        return entry
      }
    }

    return data[keys[0]]
  }

  /**
   * Преобразуем данные для массива
   * @param data
   */
  const getProgramData = (data: any) => {
    const result: number[][] = []

    for (let key in data) {
      if (!Number(key)) continue

      result.push(toArray(data[key]))
    }

    return result
  }

  return {
    data,
    scheduleData,

    loadData,
  }
}
